"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmtpMicroservicePatterns = void 0;
var SmtpMicroservicePatterns;
(function (SmtpMicroservicePatterns) {
    SmtpMicroservicePatterns["NewMailAccount"] = "SMTP_NEW_MAIL_ACCOUNT";
    SmtpMicroservicePatterns["UpdateMailAccount"] = "SMTP_UPDATE_MAIL_ACCOUNT";
    SmtpMicroservicePatterns["ScheduleReconnectMailAccount"] = "SCHEDULE_RECONNECT_SMTP_MAIL_ACCOUNT";
    SmtpMicroservicePatterns["ReconnectMailAccount"] = "RECONNECT_SMTP_MAIL_ACCOUNT";
    SmtpMicroservicePatterns["DeleteMailAccount"] = "SMTP_DELETE_MAIL_ACCOUNT";
    SmtpMicroservicePatterns["SendMail"] = "SEND_MAIL";
    SmtpMicroservicePatterns["SendLogMail"] = "SEND_LOG_MAIL";
    SmtpMicroservicePatterns["SendLocalMail"] = "SEND_LOCAL_MAIL";
})(SmtpMicroservicePatterns = exports.SmtpMicroservicePatterns || (exports.SmtpMicroservicePatterns = {}));
